import styled from 'styled-components';
const Container = styled.div `
  display: block;
  height: 100%;
  width: 100%;
`;
const LottieAnimationStyles = {
    Container,
};
export default LottieAnimationStyles;
